// brokers Data
  const pages = {
    header: "LTL.AI"
  };
  
  const initState = {
    pages: pages
  }
  
  export default (state = initState, action) => {
    switch (action.type) {    
      default:
        return state
    }
  }
  


// WEBPACK FOOTER //
// ./src/store/reducers/contentReducer.jsx